import CardCommon from '@op/components/CardCommon';
import React, { useMemo } from 'react';
import { useDirectoryInfo } from '../../hooks/useDirectoryInfo';
import { DBO_V } from '@op/utils/format';
import useLanguage from '@op/hooks/useLanguage';
import followersIcon from '@op/assets/svg/followers.svg';
import viewersIcon from '@op/assets/svg/viewers.svg';
import RenderImg from '@op/components/RenderImg';
import { DefaultImg } from '@op/constants/defaultImg';
import { RankKeyMeticsItem } from '@op/pages/Overview/KeyMetrics/component/TrendCardTips';

export default function GameStreamInfo(props: { gameInfo: any }) {
  const { gameInfo } = props;
  const { formatMessage, isEn } = useLanguage();
  const { loading, directoryInfo } = useDirectoryInfo({ filter: gameInfo });
  const { name, cover, tags, followers, viewers, rankList, rank } =
    useMemo(() => {
      const {
        category_name,
        category_cover,
        tags,
        category_followers,
        viewers_count,
        top_rank_list,
        rank,
      } = directoryInfo || {};

      const rankList = top_rank_list?.map((item) => ({
        edition_unified_id: item?.unified_edition_id,
        cover: item?.category_cover,
        value: item?.viewers_count,
        entity_type: 'pc',
        entity_name: item?.category_name,
        rank: item?.rank,
      }));

      return {
        name: category_name,
        cover: category_cover,
        tags,
        followers: category_followers,
        viewers: viewers_count,
        rankList,
        rank,
      };
    }, [directoryInfo]);

  return (
    <CardCommon
      loading={loading}
      loadingHeight={95}
      className="dbo-steaming-game-info"
    >
      <div className="dbo-steaming-game-info-wrapper">
        <div className="dbo-steaming-game-info-left">
          <RenderImg
            coverImage={cover}
            defaultImage={DefaultImg.GAME}
            className="dbo-steaming-game-info-cover"
          />
        </div>
        <div className="dbo-steaming-game-info-right">
          <div className="dbo-steaming-game-info-name">{name || '-'}</div>
          <div className="dbo-steaming-game-info-stats">
            <div className="dbo-steaming-game-info-stats-item">
              <img
                src={followersIcon}
                className="dbo-steaming-game-info-stats-item-svg"
              />
              {formatMessage('Followers')}:{' '}
              {DBO_V.reviews(DBO_V.abs(followers))}
            </div>
            <div className="dbo-steaming-game-info-stats-item">
              <img
                src={viewersIcon}
                className="dbo-steaming-game-info-stats-item-svg"
              />
              {formatMessage('Viewers')}:{' '}
              {viewers ? DBO_V.reviews(viewers) : '-'}
            </div>
          </div>
          <div className="dbo-steaming-game-info-tags">
            {formatMessage('Tags')}:
            {tags && tags.length > 0
              ? tags.map((tag: { tag_zh: string; tag_en: string }) => (
                  <span
                    key={tag?.tag_en}
                    className="dbo-steaming-game-info-tag"
                  >
                    {isEn ? tag?.tag_en : tag?.tag_zh}
                  </span>
                ))
              : '-'}
          </div>
        </div>
        <div className="dbo-steaming-compare">
          <RankKeyMeticsItem
            list={rankList}
            rank={rank}
            valueKey={'viewers_count'}
            valueFormat={DBO_V.reviews}
            noShow
            title={'Viewers'}
            canNavigateToGame={false}
            mustShowRank
            rankKey="rank"
            noGoToGame
            gameTitle="Top 30 Categories"
          ></RankKeyMeticsItem>
        </div>
      </div>
    </CardCommon>
  );
}
